import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { inject as service } from '@ember/service';
import { action } from '@ember/object';
import type IntlService from 'ember-intl/services/intl';

interface FeedbackHash {
  name: string;
  email: string;
  feedback: string;
}

export interface AditoolsFeedbackDialogSignature {
  Element: HTMLDialogElement;
  Args: {
    submitFeedback: (feedback: FeedbackHash) => void;
    close: () => void;
    dialogClass?: string;
    model?: FeedbackHash;
  };
}

interface FeedbackHash {
  name: string;
  email: string;
  feedback: string;
}

export default class AditoolsFeedbackDialog extends Component<AditoolsFeedbackDialogSignature> {
  @service declare intl: IntlService;
  @tracked name = this._model.name;
  @tracked email = this._model.email;
  @tracked feedback = this._model.feedback;

  get _model() {
    return this.args.model ?? { name: '', email: '', feedback: '' };
  }

  get isDisabled() {
    return this.feedback.length === 0;
  }

  validate() {
    return this.feedback.length > 0;
  }

  @action onValueChanged(event: Event) {
    const fieldName: string = (<HTMLInputElement>event.target).id.toString();
    const value: string = (<HTMLInputElement>event.target).value.toString();
    const fieldProperties = { 'feedback-name': 'name', 'feedback-email': 'email', 'feedback-text': 'feedback' };
    if (Object.prototype.hasOwnProperty.call(fieldProperties, fieldName)) {
      // Typescript can't see that the hash makes the values safe, so we have to declare they are.
      const fieldProperty = fieldProperties[fieldName as 'feedback-name' | 'feedback-email' | 'feedback-text'];
      const fieldPropertySafe = fieldProperty as 'name' | 'email' | 'feedback';
      if (this[fieldPropertySafe] !== value) {
        this[fieldPropertySafe] = value;
      }
    }
  }

  @action giveFeedback(closeDialog: () => void) {
    if (this.validate() && this.args.submitFeedback) {
      this.args.submitFeedback({ name: this.name, email: this.email, feedback: this.feedback });
      closeDialog();
    }
  }
}
